export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}country/country`;
    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/Country/index.js